import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.051 5.684A1 1 0 0 1 6 5h12a1 1 0 0 1 .949.684L20.72 11H22a1 1 0 1 1 0 2h-1v7a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1.5H6V20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-7H2a1 1 0 1 1 0-2h1.28zM5 13v3.5h14V13zm13.613-2H5.387l1.334-4h10.558zM6 15a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1m9 0a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2h-1a1 1 0 0 1-1-1",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }